import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getWorkouts } from '../api/workouts';
import LoadingSpinner from '../components/common/LoadingSpinner';
import AlertBanner from '../components/common/AlertBanner';
import DifficultyStars from '../components/common/DifficultyStars';
import TagBadge from '../components/common/TagBadge';

export default function PresenterListPage() {
  const navigate = useNavigate();
  const [workouts, setWorkouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getWorkouts({ published_only: true })
      .then(setWorkouts)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i className="bi bi-play-circle-fill text-primary fs-3" />
        <h4 className="mb-0 fw-bold">Referentenansicht</h4>
      </div>

      <AlertBanner message={error} type="danger" onDismiss={() => setError('')} />

      {workouts.length === 0 ? (
        <div className="text-center text-muted py-5">
          <i className="bi bi-collection fs-1 d-block mb-2" />
          Keine veröffentlichten Workouts vorhanden.
        </div>
      ) : (
        <div className="row g-3">
          {workouts.map((w) => (
            <div key={w.id} className="col-sm-6 col-xl-4">
              <div
                className="card h-100 shadow-sm"
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onClick={() => navigate(`/presenter/${w.id}`)}
                onKeyDown={(e) => e.key === 'Enter' && navigate(`/presenter/${w.id}`)}
              >
                <div className="card-body d-flex flex-column">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <i className="bi bi-play-circle-fill text-primary fs-4 flex-shrink-0" />
                    <h6 className="card-title mb-0 fw-semibold flex-grow-1">{w.name}</h6>
                  </div>
                  {w.description && (
                    <p
                      className="card-text text-muted small mb-2"
                      style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                    >
                      {w.description}
                    </p>
                  )}
                  <div className="d-flex align-items-center gap-3 mb-2 small text-muted">
                    <DifficultyStars value={w.difficulty} />
                    {w.duration && (
                      <span><i className="bi bi-clock me-1" />{w.duration} Min.</span>
                    )}
                  </div>
                  {(w.tags || []).length > 0 && (
                    <div className="mt-auto d-flex flex-wrap gap-1">
                      {w.tags.map((t) => (
                        <TagBadge key={t.id} tag={t} />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
